var _defs, _rect, _text, _rect2, _text2, _rect3, _text3, _rect4, _text4, _rect5, _text5, _rect6, _text6, _rect7, _text7, _rect8, _text8, _rect9, _text9, _rect10, _switch;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgLogoSmallLight = function SvgLogoSmallLight(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "131px",
    height: "41px",
    viewBox: "-0.5 -0.5 131 41",
    content: "<mxfile host=\"www.draw.io\" modified=\"2020-03-26T23:55:53.991Z\" agent=\"Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_3) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/80.0.3987.100 Safari/537.36\" version=\"12.7.1\" etag=\"zh0woKyXmHRZOmL-1cp1\" type=\"google\"><diagram id=\"FslkHhYHOkw33hW6Jorh\">7ZjLrtsgEIafxtsITBLby+biVlWrVieVuqY2sVGxiQi59ek71HBih5yTVHKUjTcW/AyeYb4B2QRkXh0/Kropv8qciSBE+TEgiyAMxxMETyOcGiGMSCMUiueNhM/Civ9hVrTzih3P2bZjqKUUmm+6YibrmmW6o1Gl5KFrtpai63VDC+YJq4wKX/3Jc11aFSN0HvjEeFFa17FbcEWdsRW2Jc3loSWRZUDmSkrdtKrjnAmTO5eXZl76xuhrYIrV+p4JYTNhT8XOri21gemTW61mR3jXrNSVAAFDc6uV/M3mUkgFSi1rsJytuRAXEhW8qKGbQTQM9NmeKc0hjx/sQMXz3LiZHUqu2WpDM+PzAEUDmpK7OmcmUGR8wiCviy9srbsK9MbGvax1SisuTE29yF9SS6va+gmx69ulub4LOghJmqaLdA66TQuEy45vpha/AoNCZ7JiWp3AxE6IJmgU2fy6OncFcjhXDbFS2aoXp1Fbp8Xry88ooWFpXidLPLLLgWxPZKdkNLkNFjujvtGOPbSrAW1PaKPkaTt24mH9MWDtCWtCnoZ1OhzEj8Iao+k9B/GDwEYe2M8D2J7AhuiJYGMP7LcBbE9gyfOwJsNn08Owuh/cJ2B1lwItrt+p0ia6Fwifiq1xUOfwXO7NekK0YBlk4Tb7PpneZBa/g6iNEvXAK5pcbEM4bxH2kGGcjOLIx4aTHrBhD5tHpJvBazn2Nqq7j8F3bRPyTs6V1FRzaTAn6GLPt+2uHhB9MBrj0eVp6RLf/c1M4is7678JQfd87/RvrHV5R5Z/AQ==</diagram></mxfile>",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -0.28,
    y: 0,
    width: 30,
    height: 30,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 24,
      height: 1,
      paddingTop: 15,
      marginLeft: 3
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 21,
      fontFamily: "Roboto",
      color: "#FFFDFC",
      lineHeight: 1.2,
      pointerEvents: "all",
      fontWeight: "bold",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, "F")))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 15,
    y: 21,
    fill: "#FFFDFC",
    fontFamily: "Roboto",
    fontSize: "21px",
    textAnchor: "middle",
    fontWeight: "bold"
  }, "F")))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12.5,
    y: 0,
    width: 31.5,
    height: 30,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 26,
      height: 1,
      paddingTop: 15,
      marginLeft: 15
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 21,
      fontFamily: "Roboto",
      color: "#FFFDFC",
      lineHeight: 1.2,
      pointerEvents: "all",
      fontWeight: "bold",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, "E")))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 28,
    y: 21,
    fill: "#FFFDFC",
    fontFamily: "Roboto",
    fontSize: "21px",
    textAnchor: "middle",
    fontWeight: "bold"
  }, "E")))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 0,
    width: 30,
    height: 30,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 24,
      height: 1,
      paddingTop: 15,
      marginLeft: 31
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 21,
      fontFamily: "Roboto",
      color: "#FFFDFC",
      lineHeight: 1.2,
      pointerEvents: "all",
      fontWeight: "bold",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, "S")))), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 43,
    y: 21,
    fill: "#FFFDFC",
    fontFamily: "Roboto",
    fontSize: "21px",
    textAnchor: "middle",
    fontWeight: "bold"
  }, "S")))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 0,
    width: 30,
    height: 30,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 24,
      height: 1,
      paddingTop: 15,
      marginLeft: 45
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 21,
      fontFamily: "Roboto",
      color: "#FFFDFC",
      lineHeight: 1.2,
      pointerEvents: "all",
      fontWeight: "bold",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, "T")))), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 57,
    y: 21,
    fill: "#FFFDFC",
    fontFamily: "Roboto",
    fontSize: "21px",
    textAnchor: "middle",
    fontWeight: "bold"
  }, "T")))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 55.5,
    y: 0,
    width: 30,
    height: 30,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 24,
      height: 1,
      paddingTop: 15,
      marginLeft: 59
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 21,
      fontFamily: "Roboto",
      color: "#FFFDFC",
      lineHeight: 1.2,
      pointerEvents: "all",
      fontWeight: "bold",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, "E")))), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 71,
    y: 21,
    fill: "#FFFDFC",
    fontFamily: "Roboto",
    fontSize: "21px",
    textAnchor: "middle",
    fontWeight: "bold"
  }, "E")))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 69.5,
    y: 0,
    width: 30,
    height: 30,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 24,
      height: 1,
      paddingTop: 15,
      marginLeft: 73
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 21,
      fontFamily: "Roboto",
      color: "#FFFDFC",
      lineHeight: 1.2,
      pointerEvents: "all",
      fontWeight: "bold",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, "J")))), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 85,
    y: 21,
    fill: "#FFFDFC",
    fontFamily: "Roboto",
    fontSize: "21px",
    textAnchor: "middle",
    fontWeight: "bold"
  }, "J")))), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 0,
    width: 30,
    height: 30,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 24,
      height: 1,
      paddingTop: 15,
      marginLeft: 87
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 21,
      fontFamily: "Roboto",
      color: "#FFFDFC",
      lineHeight: 1.2,
      pointerEvents: "all",
      fontWeight: "bold",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, "O")))), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 99,
    y: 21,
    fill: "#FFFDFC",
    fontFamily: "Roboto",
    fontSize: "21px",
    textAnchor: "middle",
    fontWeight: "bold"
  }, "O")))), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 99,
    y: 0,
    width: 30,
    height: 30,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 24,
      height: 1,
      paddingTop: 15,
      marginLeft: 102
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 21,
      fontFamily: "Roboto",
      color: "#FFFDFC",
      lineHeight: 1.2,
      pointerEvents: "all",
      fontWeight: "bold",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, "S")))), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 114,
    y: 21,
    fill: "#FFFDFC",
    fontFamily: "Roboto",
    fontSize: "21px",
    textAnchor: "middle",
    fontWeight: "bold"
  }, "S")))), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 20.01,
    width: 119.87,
    height: 19,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 118,
      height: 1,
      paddingTop: 30,
      marginLeft: 5
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 8,
      fontFamily: "Roboto",
      color: "#FFFDFC",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, "Party Rentals and Event Decor")))), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 64,
    y: 32,
    fill: "#FFFDFC",
    fontFamily: "Roboto",
    fontSize: "8px",
    textAnchor: "middle"
  }, "Party Rentals and Event Decor")))), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: -9.65,
    y: 19,
    width: 31.98,
    height: 3,
    fill: "#fffdfc",
    stroke: "none",
    transform: "rotate(90,6.34,20.5)",
    pointerEvents: "all"
  }))), _switch || (_switch = /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("g", {
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }), /*#__PURE__*/React.createElement("a", {
    transform: "translate(0,-5)",
    xlinkHref: "https://desk.draw.io/support/solutions/articles/16000042487",
    target: "_blank"
  }, /*#__PURE__*/React.createElement("text", {
    textAnchor: "middle",
    fontSize: "10px",
    x: "50%",
    y: "100%"
  }, "Viewer does not support full SVG 1.1")))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogoSmallLight, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo_small_light.ecca762a.svg";
export { ForwardRef as ReactComponent };